import { render, staticRenderFns } from "./JobViewJobPickUpCard.vue?vue&type=template&id=3818c376&"
import script from "./JobViewJobPickUpCard.vue?vue&type=script&lang=js&"
export * from "./JobViewJobPickUpCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports